import Routes from '../core/Routes';
import ConfigureHistory from '../core/ConfigureHistory';
import { Roles } from "src/constants/Roles";
import { Grades } from "src/constants/Grades";

export default class RoleRedirect {
    constructor() {
        // Dont be that guy
        throw new Error("NOOOO");
    }

    public static GetRoleRoute(roleId: number, gradeId?: number): string {
        let role = Roles.FindById(roleId);
        let grade = Grades.FindById(gradeId);
        let route = "";

        switch (role) {
            case Roles.KuderAdmin:
                route = Routes.ADMIN_CLIENTS;
                break;
            case Roles.StateAdmin:
                route = Routes.ADMIN_DISTRICTS;
                break;
            case Roles.DistrictAdmin:
                route = Routes.ADMIN_SCHOOLS;
                break;
            case Roles.SchoolAdmin:
                let isAdminTable = true;
                route = Routes.getRoute(Routes.ADMIN_USERS, isAdminTable);
                break;
            case Roles.TeacherCounselorAdmin:
                route = Routes.ADMIN_CLASSROOMS;
                break;
            case Roles.Student:
                switch (grade) {
                    case Grades.Default:
                        console.error(`Invalid grade "${gradeId}"`);
                        break;
                    default:
                        route = Routes.STUDENT_HOME;
                        break;
                }
                break;
            default:
                console.error(`Invalid role "${roleId}"`);
                break;
        }
        if (route == null || route === "") {
            console.error("No Route selected, defaulting to login");
            route = Routes.BASE_ROUTE;
        }

        return route;
    }
}

export function roleRedirect(roleId: number, gradeId?: number) {
    let route = RoleRedirect.GetRoleRoute(roleId, gradeId);
    ConfigureHistory.push(route);
}



// WEBPACK FOOTER //
// ./src/utils/RoleRedirect.ts